exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawerable {\n  transition: margin-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms; }\n  .drawerable.shift-for-drawer {\n    margin-left: 12rem; }\n  .drawerable:not(.shift-for-drawer) {\n    margin-left: 0; }\n\n.app-drawer {\n  width: 12rem; }\n  .app-drawer .drawer-header {\n    text-align: right; }\n  .app-drawer .MuiDrawer-paper {\n    width: 12rem; }\n", ""]);

// exports
